import { SafePromise } from '@benzinga/safe-await';
import { IncludeHeader, RestfulClient, Session } from '@benzinga/session';
import { BullVsBearResponse } from '../entities';
import { QuotesEnvironment } from '../environment';

export class QuotesBullSayBearSayRestful extends RestfulClient {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    super(session.getEnvironment(QuotesEnvironment).bullSayBearSayUrl, session, includeHeaders);
  }

  getStatements = (symbols: string[]): SafePromise<BullVsBearResponse> => {
    const url = this.URL(`api/v1/bulls_bears_say`, {
      symbols: symbols.join(','),
      token: this.session.getEnvironment(QuotesEnvironment).bullSayBearSayToken,
    });
    return this.get(url, { allowsAnonymousAuth: true });
  };
}
